import { ClientSupplier } from "@interfaces/response";
import { ReferenceStructure } from "@interfaces/request";
import { CLIENT_RFC_NOT_VALID } from "@helpers/constantes";

export interface Referencia {
  id: string;
  rfc: string;
  contact_name: string;
  email: string;
  country_code: string;
  phone: string;
  phone_extension: string;
}

export interface FormValues {
  referencias: Referencia[];
}

export const referenciaVacia = (): Referencia => ({
  id: "",
  rfc: "",
  contact_name: "",
  email: "",
  country_code: "+52",
  phone: "",
  phone_extension: "",
});

export const firmaTelefono = (item: Referencia) =>
  (item.country_code || "") + (item.phone || "") + (item.phone_extension || "");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const estaCompleta = (item: Referencia, isVisible?: (field: any) => boolean) => {
  const visible = isVisible ?? (() => true);
  return Boolean(
    item.rfc &&
      (!visible("contact_name") || item.contact_name) &&
      (!visible("email") || item.email) &&
      (!visible("phone_number") || (item.country_code && item.phone)),
  );
};

export const aReferencias = (
  registros: ReferenceStructure[],
  count: number,
  campoRfc: "company_rfc" | "supplier_rfc",
): Referencia[] => {
  const guardadas = registros.slice(0, count).map((item) => ({
    id: item.id as string,
    rfc: item[campoRfc] || "",
    contact_name: item.contact_name,
    email: item.email,
    country_code: item.code_phone_number,
    phone: item.phone_number,
    phone_extension: item.phone_extension,
  }));
  return [...guardadas, ...Array.from({ length: Math.max(0, count - guardadas.length) }, referenciaVacia)];
};

export const opcionesDisponibles = (index: number, catalogo: ClientSupplier[], lista: Referencia[]): ClientSupplier[] =>
  catalogo
    .filter((item) => !lista.some((ref, refIndex) => refIndex !== index && ref.rfc === item.rfc))
    .filter((item) => !CLIENT_RFC_NOT_VALID.includes(item.rfc))
    .sort((a, b) => a.name.localeCompare(b.name));
